import { type MarketCreateDto, postMarkets } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { MARKET_LIST } from "Market/Api/Query/useMarketListQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const marketMutationsResource = Resources.base.market.mutations;

export const useCreateMarketMutation = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: MarketCreateDto) => postMarkets(data)),
		onError: (error) => {
			console.error(`${t(marketMutationsResource.createMarketError)}:`, error);
		},
		onSuccess: () => {
			toast.success(t(marketMutationsResource.createMarketSuccess));
			queryClient.invalidateQueries({ queryKey: [MARKET_LIST] });
		},
	});
};
